var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediumBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.462 5.09a3.277 3.277 0 013.281 3.273 3.277 3.277 0 01-3.281 3.272A3.277 3.277 0 012.18 8.363 3.277 3.277 0 015.462 5.09zm5.24.192c.907 0 1.641 1.379 1.641 3.08 0 1.702-.734 3.082-1.64 3.082-.907 0-1.641-1.38-1.641-3.081 0-1.702.734-3.081 1.64-3.081zm2.537.32c.319 0 .577 1.236.577 2.76 0 1.525-.258 2.76-.577 2.76-.319 0-.577-1.235-.577-2.76 0-1.524.258-2.76.577-2.76z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBlack);
export default __webpack_public_path__ + "static/media/medium_black.cf9cd0fc5852810bba6d6ee997102eaa.svg";
export { ForwardRef as ReactComponent };